import { render, staticRenderFns } from "./shuzhi.vue?vue&type=template&id=6db7b6f3&scoped=true"
import script from "./shuzhi.vue?vue&type=script&lang=js"
export * from "./shuzhi.vue?vue&type=script&lang=js"
import style0 from "./shuzhi.vue?vue&type=style&index=0&id=6db7b6f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db7b6f3",
  null
  
)

export default component.exports